import React from "react";
import Popup from "./BasePopup";
import PremiumTextLogo from "../Common/PremiumTextLogo";
import Button from "../CommonFields/Button";

const BaseSubscriptionPopup = ({ isOpen, onClose, title, children,onSubscriptionBtnClick }) => {
  return (
    <Popup isOpen={isOpen} onClose={onClose} >
      <PremiumTextLogo />

      {children}
      <div className="my-4 mb-2">
       
        <Button text={title} onClick={onSubscriptionBtnClick}/>
      </div>
    </Popup>
  );
};

export default BaseSubscriptionPopup;
